// NumberOfGuestsPicker.js
import React, {memo} from 'react';
import { useTranslation } from 'react-i18next';
import {View, Text, TextInput, TouchableOpacity} from 'react-native';

const NumberOfGuestsPicker = memo(props => {
  const {numberOfGuests, onIncrease, onDecrease, onChangeText, getStyles} = props || {};

  const { t } = useTranslation();

  return (
    <View style={getStyles(['guestsContainer'])}>
      <Text style={getStyles(['guestsText'])}>{t('tableRes.number_of_guest')} <Text style={getStyles(['tableReservationStar'])}>*</Text></Text>
      <View style={getStyles(['guestsInput'])}>
        <TextInput
          style={getStyles(['guestsNumberInput'])}
          keyboardType="numeric"
          value={numberOfGuests.toString()}
          onChangeText={onChangeText}
        />
        <TouchableOpacity style={getStyles(['guestsButton'])} onPress={onIncrease}>
          <Text style={getStyles(['guestsButtonText'])}>+</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={getStyles(['guestsButton'])}
          onPress={onDecrease}
          disabled={numberOfGuests === 0}>
          <Text style={getStyles(['guestsButtonText'])}>-</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
});

export default NumberOfGuestsPicker;
